import {from} from "rxjs";
import axios from "axios";
import {map} from "rxjs/operators";


export const getCitySuggestions = (keyword) => (from(
      axios.get(global.API_URL + `/smartcomplete.jsp?type=location&query=${keyword}`)
   ).pipe(
      map((res) => {
            const {status, data} = res;
            if (status !== 204 && data) {
               const {results} = data;
               return results ?
                  results.map(result => ({
                     ...result,
                     label: result.location,
                     value: result.city
                  }))
                  : [];
            } else {
               return [];
            }
         }
      ))
);
